import { render, staticRenderFns } from "./EmailQuestion.vue?vue&type=template&id=62141410&scoped=true&"
import script from "./EmailQuestion.vue?vue&type=script&lang=js&"
export * from "./EmailQuestion.vue?vue&type=script&lang=js&"
import style0 from "./EmailQuestion.vue?vue&type=style&index=0&id=62141410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62141410",
  null
  
)

component.options.__file = "EmailQuestion.vue"
export default component.exports